import React from 'react';

import './SellBankReview.scss';

import If from '../../Shared/If/If';
import { DELIVERY_DIRECT_DEPOSIT } from '../../../settings/settings';
import { hasValue, titleCase } from '../../../utils/utils';

const SellBankReview = ({ deliveryMethod, selectedBank }) => (
  <div className="sell-bank-review">
    <div className="sell-bank-review-delivery-method">
      {deliveryMethod === DELIVERY_DIRECT_DEPOSIT
        ? 'DIRECT DEPOSIT'
        : 'WIRE TRANSFER'}
    </div>
    <div className="sell-bank-review-bank-name">
      {titleCase(selectedBank.name)} -{' '}
      {`${titleCase(selectedBank.bankAccountType)} `}
      <span className="blocked_data">{selectedBank.accountNumber}</span>
    </div>
    <div>
      <If test={hasValue(selectedBank.registrationLines)}>
        <div className="blocked_data sell-bank-review-bank-owner-name">
          {selectedBank.registrationLines &&
            selectedBank.registrationLines.join(', ')}
        </div>
      </If>
    </div>
  </div>
);

export default SellBankReview;
